// app/javascript/controllers/copy_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["text"];

  copy() {
    const text = this.textTarget.innerText;
    navigator.clipboard
      .writeText(text)
      .then(() => {
        alert("Copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  }
}
